import React from 'react';
import { Tabs } from 'tdesign-react';
import TabPanel from 'tdesign-react/es/tabs/TabPanel';
import Markdown from '@/pages/Dev/components/Markdown';
import { doBuried } from '@/services/buriedService';

export default function Code({ brokerServiceUrl }) {
  const content1 = `
  如果使用maven构建项目，将下述配置添加到 pom.xml 文件中：

  ~~~xml~DEV_SPRING_BOOT_MAVEN_GRADLE_1_COPY
  <dependencies>
      <dependency>
          <groupId>org.springframework.pulsar</groupId>
          <artifactId>spring-pulsar-spring-boot-starter</artifactId>
          <version>0.2.0-SNAPSHOT</version>
      </dependency>
  </dependencies>
  
  ~~~
  
  如果使用gradle构建项目，将下述配置添加到 build.gradle文件中：
  
  ~~~groovy~DEV_SPRING_BOOT_MAVEN_GRADLE_2_COPY
  dependencies {
      implementation 'org.springframework.pulsar:spring-pulsar-spring-boot-starter:0.2.0-SNAPSHOT'
  }
  ~~~
  
  application.yaml中的pulsar相关配置
  
  ~~~yaml~DEV_SPRING_BOOT_MAVEN_GRADLE_3_COPY
  spring:
    pulsar:
      client:
        service-url: ${brokerServiceUrl}
        auth-plugin-class-name: org.apache.pulsar.client.impl.auth.AuthenticationToken
        authentication:
        # YOUR_PULSAR_TOKEN需要在角色菜单中自行配置
          token: YOUR_PULSAR_TOKEN
  ~~~
  `;
  const content2 = `
  ~~~java~DEV_SPRING_BOOT_PRODUCER_COPY
  @Autowired
  PulsarTemplate<T> pulsarTemplate;

  //消息发送
  public MessageId sendMessage(String topic, T message) throws PulsarClientException {
      return this.pulsarTemplate.send(topic, message);
  }

  //异步消息发送
  public CompletableFuture<MessageId> sendMessageAsync(String topic, T message) throws PulsarClientException {
      return this.pulsarTemplate.sendAsync(topic, message);
  }

  //延迟消息发送
  public MessageId sendDelayMessage(String topic, T message, long delay, TimeUnit unit) throws PulsarClientException {
      /**
       * MessageCustomizer可以用来来配置消息延迟、在特定时间发送、禁用跨地域复制等。
       */
      return this.pulsarTemplate.newMessage(message).withTopic(topic)
              .withMessageCustomizer(m -> {
                  m.deliverAfter(delay,unit).disableReplication();
              }).send();
  }

  //自定义produce参数发送消息
  public MessageId sendMessageWithProducerCustomizer(String topic, T message, int timeout, TimeUnit unit, BatcherBuilder builder) throws PulsarClientException {
      /**
       * ProducerCustomizer可用于添加超时时间、访问模式、自定义消息路由和拦截器，以及启用或禁用chunk和batch等。
       */
      return this.pulsarTemplate.newMessage(message).withTopic(topic)
              .withProducerCustomizer(pc->{
                  pc.batcherBuilder(builder).sendTimeout(timeout,unit).enableBatching(true).batchingMaxMessages(10);
              }).send();
  }
  ~~~
  `;
  const content3 = `
  ~~~java~DEV_SPRING_BOOT_CONSUMER_COPY
  //1.接受默认类型消息
  @PulsarListener(
          subscriptionName = "sub-test",
          topics = STRING_TOPIC,
          subscriptionType = SubscriptionType.Shared
  )
  public void stringTopicListener(Message<byte[]>  message) {
      /*
       * 1.topic 生产和消费使用的schema要匹配，否则无法没收到消息
       * 2.生产者如果没有显示的指定发送时的schema，则默认为byte[]
       */
      System.out.println("Received byte message: " + new String(message.getValue()) + ", produce name : " + message.getProducerName());

  }
  
  //2.接受自定义类型消息
  @PulsarListener(
          subscriptionName = "sub-test",
          topics = PERSON_TOPIC,
          subscriptionType = SubscriptionType.Shared,
          schemaType = SchemaType.JSON
  )
  public void personTopicListener(Message<Person> message) {
      /**
       * AVRO或JSON类型的schema,需要提前为PulsarClient注册配置其schema信息
       */
      System.out.println("Received object message: " + message.getValue() + ", produce name : " + message.getProducerName());
  }
  @Bean
  public SchemaResolver.SchemaResolverCustomizer<DefaultSchemaResolver> schemaResolverCustomizer() {
      //给自定义对象注册schema
      return (schemaResolver) -> {
          schemaResolver.addCustomSchemaMapping(Person.class, Schema.JSON(Person.class));
      };
  }

  ~~~
  `;
  return (
    <Tabs
      defaultValue='DEV_SPRING_BOOT_MAVEN_GRADLE'
      onChange={(val) => doBuried({ eventId: val })}
    >
      <TabPanel value='DEV_SPRING_BOOT_MAVEN_GRADLE' label='Maven/Gradle'>
        <Markdown content={content1} />
      </TabPanel>
      <TabPanel value='DEV_SPRING_BOOT_PRODUCER' label='Producer'>
        <Markdown content={content2} />
      </TabPanel>
      <TabPanel value='DEV_SPRING_BOOT_CONSUMER' label='Consumer'>
        <Markdown content={content3} />
      </TabPanel>
    </Tabs>
  );
}
